import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import { Button, Badge } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import { Tooltip, OverlayTrigger, Dropdown } from "react-bootstrap";
import $ from 'jquery';
import axios from 'axios';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
// import Add from './../../../modal/Catering_Management/Manage_Customer/AddCustomer';
import Edit from './../../../modal/Corporate_Management/Manage_Customer/EditCustomer';
// import View from './../../../modal/Catering_Management/Manage_Customer/ViewCustomer';
import new_gif from '../../../../images/new_subs.gif';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const ManageCustomer = () => {

    const tableRef = useRef(null);

    const [modalType, setModalType] = useState("");
    const [open, setOpen] = useState(false);
    const [customers, setCustomers] = useState([]);
    const BaseUrl = process.env.REACT_APP_API_BASE_URL;
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const navigate = useNavigate();

    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(25);
    const [searchTerm, setSearchTerm] = useState('');
    const [total_entries, setTotslEntries] = useState(0);
    const [datas, setData] = useState([]);
    const [totalEntries, setTotalEntries] = useState(0);
    const [paymentModeMap, setPaymentModeMap] = useState({});
    const [loading, setLoading] = useState(true);

    const fetchPaymentModes = async () => {
        try {
            const response = await axios.get(`${BaseUrl}/paymentmode/getactive`);
            if (response.data && Array.isArray(response.data)) {
                const map = {};
                response.data.forEach(pm => {
                    map[pm.sno] = pm.paymentmode_name;
                });
                setPaymentModeMap(map);
            } else {
                setPaymentModeMap({});
            }
        } catch (error) {
            console.error('Failed to fetch payment modes:', error);
            setPaymentModeMap({});
        }
    };

    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);

    const fetchCustomers = async () => {
        try {
            const response = await axios.get(`${BaseUrl}/manage_corporate_customer/list`, {
                params: { branch_id }
            });
            if (Array.isArray(response.data)) {
                setCustomers(response.data);
                setLoading(false);
            } else {
                setCustomers([]);
                setLoading(false);
            }
        } catch (error) {
            console.error('Error fetching customers:', error);
            setCustomers([]);
            toast.error('Error', 'Failed to fetch customer data', 'error');
        }
    };

    const filteredCustomers = customers.filter(cust => {
        const baseMatch =
            String(cust.customer_name || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            String(cust.customer_number || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            String(cust.customer_email || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            String(cust.area || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            String(cust.lead_source || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            String(paymentModeMap[cust.payment_method] || cust.payment_method || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            String(cust.orders?.length || 0).includes(searchTerm);

        const orderMatch = cust.orders?.some(order =>
            String(order.catering_id || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            String(order.function_type || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            String(order.catering_type || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            String(order.total || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            String(order.advance_amount || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            String(order.head_count || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
            String(order.order_status || '').toLowerCase().includes(searchTerm.toLowerCase())
        );

        return baseMatch || orderMatch;
    });

    const paginatedCustomers = filteredCustomers.slice((page - 1) * perPage, page * perPage);
    const totalPages = Math.ceil(filteredCustomers.length / perPage);


    const handleStatusChange = async (sno, checked) => {
        const newStatus = checked ? '0' : '1';
        try {
            await axios.put(`${BaseUrl}/manage_corporate_customer/update_status/${sno}`, { status: newStatus });
            toast.success('Status Updated Successfully');
        } catch (error) {
            toast.error(error);
            console.error("Status update failed:", error);
        }
    };

    const handleModalToggle_Edit = (customer) => {
        setSelectedCustomer(customer);
        setModalType("Edit");
        setOpen(true);
    };

    const [isVisible, setIsVisible] = useState({
        firstrow: false
    });

    const toggleDiv = (section) => {
        setIsVisible((prev) => ({
            ...prev,
            [section]: !prev[section],
        }));
    };

    const handleView = (customerId) => {
        localStorage.removeItem('selectedCustomerId');
        localStorage.setItem('selectedCustomerId', customerId);
        navigate('/corporate-customer-view');
    };

    const handleOrder = (customerId) => {
        localStorage.removeItem('selectedCustomerId');
        localStorage.setItem('selectedCustomerId', customerId);
        navigate('/corporate-order');
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        return date.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    };

    const getOrderStatus = (status) => {
        const map = {
            "1": { label: "Ordered", bgColor: "#fff700", textColor: "#000" },
            "2": { label: "Order Confirmed", bgColor: "#9ff551", textColor: "#000" },
            "3": { label: "Order Postponed", bgColor: "#18bff1", textColor: "#fff" },
            "4": { label: "Order Cancelled", bgColor: "#ff1a1aba", textColor: "#fff" },
            "5": { label: "Payment Pending", bgColor: "#7e00afff", textColor: "#fff" },
            "6": { label: "Out For Delivery", bgColor: "#536ae3", textColor: "#fff" },
            "7": { label: "Delivered", bgColor: "#00812d", textColor: "#fff" },
            "8": { label: "Paid", bgColor: "#00812d", textColor: "#fff" },
            "9": { label: "Refund Initiated", bgColor: "#fff700", textColor: "black" },
            "10": { label: "Refunded", bgColor: "#536ae3", textColor: "white" },
        };

        return map[status] || { label: "Unknown", bgColor: "#ccc", textColor: "#000" };
    };

    useEffect(() => {
        fetchCustomers();
        fetchPaymentModes();
    }, []);

    useEffect(() => {
        if (tableRef.current) {
            if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable({
                    "responsive": true,
                    pageLength: 25,
                    "ordering": false,
                    "language": {
                        "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
                    },
                    "dom":
                        "<'row'" +
                        "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        }
    }, [customers]);

    return (
        <>
            {loading ? (
                <div className="d-flex align-items-center justify-content-between flex-wrap page-titles px-0 py-1 mx-0">
                    <div className='mb-2'>
                        <div className="mb-0 px-0">
                            <h4 style={{ color: '#025d3a' }}><Skeleton width={150} /></h4>
                        </div>
                        <ol className="breadcrumb fs-7">
                            <li className="breadcrumb-item"><Skeleton width={70} /></li>
                            <li className="breadcrumb-item"><Skeleton width={20} /></li>
                            <li className="breadcrumb-item active"><Skeleton width={100} /></li>
                        </ol>
                    </div>
                </div>
            ) : (
                <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                    <div className='mb-0'>
                        <div className="mb-0 px-0">
                            <h4 className='breadcrumb-header'>Manage Corporate Customer</h4>
                        </div>
                        <ol className="breadcrumb fs-7">
                            <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                            <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                            <li className="breadcrumb-item active">Corporate Management</li>
                        </ol>
                    </div>
                    {open && modalType === "Edit" && selectedCustomer && (
                        <Edit
                            show={open}
                            onClose={() => setOpen(false)}
                            customerData={selectedCustomer}
                            id={selectedCustomer.sno}
                            onUpdated={fetchCustomers}
                        />

                    )}

                </div>
            )}

            {loading ? (
                <div className="table-container">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        {/* Left: Show entries dropdown */}
                        <div>
                            <label className="me-2"><Skeleton width={50} height={25} /></label>
                            <Skeleton width={50} height={25} className="mb-1" />
                        </div>

                        {/* Right: Search input */}
                        <div>
                            <Skeleton width={150} height={25} className="mb-1" />
                        </div>
                    </div>

                    <table style={{ borderBottom: '2px solid #ddd' }} id="kt_datatable_responsive_approved" className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                        <thead>
                            <tr>
                                <th><Skeleton width={100} height={16} /></th>
                                <th><Skeleton width={100} height={16} /></th>
                                <th><Skeleton width={100} height={16} /></th>
                                <th><Skeleton width={100} height={16} /></th>
                                <th><Skeleton width={100} height={16} /></th>
                                <th><Skeleton width={100} height={16} /></th>
                            </tr>
                        </thead>
                        <tbody className="text-gray-600 fw-semibold fs-7">
                            {[...Array(perPage)].map((_, i) => (
                                <tr key={i}>
                                    <td><Skeleton /></td>
                                    <td><Skeleton /></td>
                                    <td><Skeleton /></td>
                                    <td><Skeleton /></td>
                                    <td><Skeleton /></td>
                                    <td><Skeleton /></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <div className="d-flex justify-content-between align-items-center mt-3">
                        {/* Bottom left: Showing x to y of z entries */}
                        <div>
                            <Skeleton width={180} height={15} />
                        </div>

                        {/* Bottom right: Pagination */}
                        <nav>
                            <div className="d-flex gap-2">
                                {[...Array(4)].map((_, i) => (
                                    <Skeleton key={i} width={40} height={25} borderRadius={5} />
                                ))}
                            </div>
                        </nav>
                    </div>
                </div>
            ) : (
                <div className="table-container">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <div>
                            <label className="me-2">Show</label>
                            <select
                                className="form-select d-inline w-auto"
                                style={{ fontSize: '0.85rem', height: '30px' }}
                                value={perPage}
                                onChange={e => { setPerPage(Number(e.target.value)); setPage(1); }}
                            >
                                {[10, 25, 50, 100].map(n => (
                                    <option key={n} value={n}>{n}</option>
                                ))}
                            </select>
                        </div>

                        <div>
                            <input
                                type="text"
                                style={{ fontSize: '0.85rem', height: '40px' }}
                                placeholder="Search..."
                                className="form-control"
                                value={searchTerm}
                                onChange={e => { setSearchTerm(e.target.value); setPage(1); }}
                            />
                        </div>
                    </div>
                    <table id="kt_datatable_responsive_approved" className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                        <thead>
                            <tr className=" text-start text-muted fw-bold fs-6 gs-0 th_head">
                                <th className='min-w-100px'>Customers</th>
                                <th className='min-w-80px'>Area / Email</th>
                                <th className='min-w-100px'>Lead Source / Pincode</th>
                                <th className='min-w-50px text-center'>Order Count</th>
                                <th className='min-w-80px text-center'>Status</th>
                                <th className='min-w-80px text-end'>Actions</th>
                            </tr>
                        </thead>
                        <tbody className="text-gray-600 fw-semibold fs-7">
                            {paginatedCustomers.length > 0 ? paginatedCustomers.map((cust, index) => (
                                <React.Fragment key={cust.sno || index}>
                                    <tr style={isVisible[`row${index}`] ? { backgroundColor: 'rgb(255 240 240)' } : {}}>
                                        <td>
                                            <div className='d-flex align-items-center justify-content-start gap-2'>
                                                <Button variant="primary tp-btn-light border px-2 pt-1 pb-0 me-1" onClick={() => toggleDiv(`row${index}`)}>
                                                    {isVisible[`row${index}`] ? (
                                                        <span><i className="fa-solid fa-angle-down fs-4"></i></span>
                                                    ) : (
                                                        <span><i className="fa-solid fa-angle-right px-1 py-1 fs-4"></i></span>
                                                    )}
                                                </Button>
                                                <div className='d-flex flex-column align-items-start'>
                                                    <label className='text-black font-w600 fs-7'>{cust.customer_name}</label>
                                                    <label className='text-primary font-w600 fs-8'>{cust.customer_number}</label>
                                                </div>
                                            </div>
                                        </td>

                                        <td>
                                            <label className='text-black font-w600 fs-7'>{cust.area}</label>
                                            <div className='d-block'>
                                                <label className='text-dark font-w600 fs-8'>{cust.customer_email}</label>
                                            </div>
                                        </td>

                                        <td>
                                            <label className='text-primary font-w600 fs-7'>{cust.lead_source}</label>
                                            <div className='d-block'>
                                                {cust.pincode && (
                                                    <label className='text-danger border border-danger py-1 px-2 rounded font-w600 fs-7'>
                                                        {cust.pincode}
                                                    </label>
                                                )}
                                            </div>
                                        </td>

                                        <td className='text-center'>
                                            <Badge bg="info" className='py-0 px-2 fs-8'>{cust.orders ? cust.orders.length : 0}</Badge>
                                            {new Date(cust.created_at).toDateString() === new Date().toDateString() && (
                                                <div className='d-flex flex-wrap justify-content-center'>
                                                    <img src={new_gif} alt="New Lead" className='w-60px h-20px' />
                                                </div>
                                            )}
                                        </td>

                                        <td className='text-center'>
                                            <div className="form-check form-switch d-flex align-items-center justify-content-center mb-3">
                                                <input className="form-check-input me-2" type="checkbox" role="switch" defaultChecked={cust.status === 0} onChange={(e) => handleStatusChange(cust.sno, e.target.checked)} />
                                            </div>
                                        </td>
{/* 
                                        <td>
                                            <span className="text-end">
                                                <Dropdown drop=''>
                                                    <Dropdown.Toggle as="a" className="i-false cursor-pointer">
                                                        <Button variant="primary tp-btn-light px-3 py-2">
                                                            <span><i className="fa-solid fa-ellipsis-vertical fs-6 mt-1"></i></span>
                                                        </Button>
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        <Dropdown.Item onClick={() => handleView(cust.sno)} className='px-2 py-1'>
                                                            <div className='d-flex align-items-center'>
                                                                <div className="rounded px-1 py-1 text-center bg-transparent me-0">
                                                                    <span><i className="fa-solid fa-eye fs-5 text-danger"></i></span>
                                                                </div>
                                                                <div className="ms-1 fs-7">View</div>
                                                            </div>
                                                        </Dropdown.Item>

                                                        <Dropdown.Item onClick={() => handleModalToggle_Edit(cust)} className='px-2 py-1'>
                                                            <div className='d-flex align-items-center'>
                                                                <div className="rounded px-1 py-1 text-center bg-transparent me-0">
                                                                    <span><i className="fa-solid fa-edit fs-5 text-danger"></i></span>
                                                                </div>
                                                                <div className="ms-2 fs-7">Edit</div>
                                                            </div>
                                                        </Dropdown.Item>

                                                        <Dropdown.Item onClick={() => handleOrder(cust.sno)} className='px-2 py-1'>
                                                            <div className='d-flex align-items-center'>
                                                                <div className="rounded px-1 py-1 text-center bg-transparent me-0">
                                                                    <span><i className="fa-solid fa-cart-plus fs-5 text-danger"></i></span>
                                                                </div>
                                                                <div className="ms-2 fs-7">Take Order</div>
                                                            </div>
                                                        </Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </span>
                                        </td> */}

                                              <td  class="text-end">
                                                              <span class="text-end">
                                                              
                                                              <OverlayTrigger
                                                                    trigger={['hover', 'focus']}
                                                                    placement="bottom"
                                                                    overlay={
                                                                        <Tooltip className='toltip-popover'>
                                                                        <span className='fs-8 text-white fw-semibold'>View</span>
                                                                        </Tooltip>
                                                                    }
                                                                    >
                                                                    <Button
                                                                        variant="primary tp-btn-light px-2 py-1 me-1"
                                                                        onClick={() => handleView(cust.sno)}
                                                                    >
                                                                        <span>
                                                                        <i className="fa-solid fa-eye fs-5"></i>
                                                                        </span>
                                                                    </Button>
                                                                </OverlayTrigger>
                                                              
                                        
                                                                <OverlayTrigger
                                                                    trigger={['hover', 'focus']}
                                                                    placement="bottom"
                                                                    overlay={
                                                                        <Tooltip className='toltip-popover'>
                                                                        <span className='fs-8 text-white fw-semibold'>Edit</span>
                                                                        </Tooltip>
                                                                    }
                                                                    >
                                                                    <Button
                                                                        variant="primary tp-btn-light px-2 py-1 me-1"
                                                                        onClick={() => handleModalToggle_Edit(cust)}
                                                                    >
                                                                        <span>
                                                                        <i className="fa-solid fa-edit fs-5"></i>
                                                                        </span>
                                                                    </Button>
                                                                </OverlayTrigger>
                                                            
                                                              <OverlayTrigger
                                                                    trigger={['hover', 'focus']}
                                                                    placement="bottom"
                                                                    overlay={
                                                                        <Tooltip className='toltip-popover'>
                                                                        <span className='fs-8 text-white fw-semibold'>Take Order</span>
                                                                        </Tooltip>
                                                                    }
                                                                    >
                                                                    <Button
                                                                        variant="primary tp-btn-light px-2 py-1 me-1"
                                                                        onClick={() => handleOrder(cust.sno)}
                                                                    >
                                                                        <span>
                                                                        <i className="fa-solid fa-file-pen"></i> 
                                                                        </span>
                                                                    </Button>
                                                                </OverlayTrigger>
                                                              
                                                              </span>
                                                            </td>
                                    </tr>

                                    {/* 🔽 Expanded Row for Orders */}
                                    {isVisible[`row${index}`] && (
                                        <tr style={{ backgroundColor: '#ffffff' }}>
                                            <td colSpan={6}>
                                                <table className="table align-top table-striped table-hover fs-7 gy-1 gs-2">
                                                    <thead>
                                                        <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                                            <th className='min-w-100px'>Order Id / Ordered Date</th>
                                                            <th className='min-w-50px text-center'>Delivery Dates / Time</th>
                                                            <th className='min-w-80px'>Total Amount</th>
                                                            <th className='min-w-80px'>Paid Amount</th>
                                                            <th className='min-w-80px'>
                                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Payment Closing Date</span></Tooltip>} >
                                                                    <span>PCD</span>
                                                                </OverlayTrigger> / Head Count
                                                            </th>
                                                            <th className='min-w-50px'>Order Status</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody className="text-gray-600 fw-semibold fs-7">
                                                        {cust.orders?.length > 0 ? cust.orders.map((order, orderIndex) => (
                                                            <tr key={order.id || orderIndex}>
                                                                <td>
                                                                    <div className="d-flex flex-column align-items-start justify-content-start">
                                                                        <div className='d-flex flex-row align-items-center justify-content-start gap-1'>
                                                                            <label className='text-black font-w500 fs-7'>{order.catering_id}</label>
                                                                            {new Date(order.created_at).toDateString() === new Date().toDateString() && (
                                                                                <img src={new_gif} alt="New Lead" className="w-60px h-20px" />
                                                                            )}
                                                                        </div>
                                                                        <label className='d-flex flex-row align-items-center justify-content-start gap-1'>
                                                                            <label className='text-primary font-w600 fs-7'>{formatDate(order.created_at)}</label>
                                                                        </label>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div className='d-flex flex-column align-items-center justify-content-start gap-1'>
                                                                        <label className='d-flex flex-row align-items-center justify-content-start gap-1'>
                                                                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Start Date</span></Tooltip>} >
                                                                                <span className='text-primary fs-7 font-w600  py-1 px-1'>{formatDate(order.order_date)}</span>
                                                                            </OverlayTrigger>
                                                                            {order.order_end_date && (
                                                                                <>
                                                                                    <span>-</span>
                                                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>End Date</span></Tooltip>} >
                                                                                        <span className='text-danger fs-7 font-w600 py-1 px-1'>{order.order_end_date ? formatDate(order.order_end_date) : ''}</span>
                                                                                    </OverlayTrigger>
                                                                                </>
                                                                            )}
                                                                        </label>
                                                                        <div>
                                                                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Delivery Time</span></Tooltip>} >
                                                                                <Badge bg="warning" className="py-1 px-2 fs-7 text-white">
                                                                                    {new Date(`1970-01-01T${order.order_time}`).toLocaleTimeString([], {
                                                                                        hour: '2-digit',
                                                                                        minute: '2-digit',
                                                                                        hour12: true,
                                                                                    })}
                                                                                </Badge>
                                                                            </OverlayTrigger>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <OverlayTrigger trigger="['hover','trigger']" placement="bottom" overlay={<Tooltip className='toltip-popover'><span className='fs-8 text-white fw-semibold'>Total Amount</span></Tooltip>}>
                                                                        <Badge bg="danger" className='py-1 px-2 font-w500 fs-7'>₹ {order.total}</Badge>
                                                                    </OverlayTrigger>
                                                                </td>
                                                                <td>
                                                                    <label className='text-white font-w500 fs-6 py-1 px-2 rounded' style={{ backgroundColor: '#5f9ea0' }}>
                                                                        ₹ {order.paid_amount}
                                                                    </label>
                                                                </td>
                                                                <td>
                                                                    <div className='d-flex flex-column align-items-center justify-content-start gap-1'>
                                                                        <label className='text-danger font-w600 fs-7'>{formatDate(order.payment_closing_date)}</label>
                                                                        <label className='text-primary font-w600 fs-7 border border-primary rounded py-1 px-2'>{order.head_count}</label>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <label style={{ backgroundColor: getOrderStatus(order.order_status).bgColor, color: getOrderStatus(order.order_status).textColor, }} className="font-w500 fs-6 py-1 px-2 rounded" >{getOrderStatus(order.order_status).label}</label>
                                                                </td>
                                                            </tr>
                                                        )) : (
                                                            <tr>
                                                                <td colSpan={6} className='text-center'>No orders found.</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            )) : (
                                <tr>
                                    <td colSpan="6" className="text-center">No customers found.</td>
                                </tr>
                            )}
                        </tbody>

                    </table>
                    <div className="d-flex justify-content-between align-items-center mt-3">
                        <div>
                            {customers.length > 0 ? (
                                <span className="text-muted">
                                    Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + paginatedCustomers.length} of {filteredCustomers.length} entries
                                </span>
                            ) : (
                                <span className="text-muted">
                                    Showing 0 to 0 of 0 entries
                                </span>
                            )}
                        </div>

                        <nav>
                            <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
                                </li>

                                <li className={`page-item ${page === 1 ? 'active' : ''}`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(1)}>1</button>
                                </li>

                                {page > 3 && <li className="page-item disabled"><span className="page-link">...</span></li>}

                                {page > 2 && (
                                    <li className="page-item">
                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>
                                            {page - 1}
                                        </button>
                                    </li>
                                )}

                                {page !== 1 && page !== totalPages && (
                                    <li className="page-item active">
                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }}>
                                            {page}
                                        </button>
                                    </li>
                                )}

                                {page < totalPages - 1 && (
                                    <li className="page-item">
                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>
                                            {page + 1}
                                        </button>
                                    </li>
                                )}

                                {page < totalPages - 2 && <li className="page-item disabled"><span className="page-link">...</span></li>}

                                {totalPages > 1 && (
                                    <li className={`page-item ${page === totalPages ? 'active' : ''}`}>
                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(totalPages)}>
                                            {totalPages}
                                        </button>
                                    </li>
                                )}

                                <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            )}
        </>
    )
}

export default ManageCustomer;
